import styled from "styled-components";

export const BoxPaper = styled("div")({
  boxShadow: "0 4px 4px 0 rgba(23, 23, 23, 0.06)",
  width: "100%",
  padding: "1rem 1rem",
  borderRadius: "1rem",
  border: "1px solid #eee",
  backgroundColor: "#fff",
});
